import React, {FC} from 'react';

const TemperatureFormatter: FC<{value: number, decimals?: number}> = ({value, decimals=1}) => <><b>{Math.round(value * 10**decimals) / 10**decimals}</b>ºC</>;

export default TemperatureFormatter;
